'use client';

import { useState } from 'react';
import styles from "./FaqWithCategory.module.scss";
import cn from "clsx";
import ArrowSVG from '@/SvgIcons/ArrowDown';
import Markdown from '@/components/atoms/Markdown';

const FaqWithCategory = ({ QuestionAnswer }) => {
  
  const tabs = [];
  const categorizedFAQs = QuestionAnswer.reduce((acc, item) => {
    if(!item?.enabled) return acc;
    const type = item.Type?item.Type.replace(/_/g, " ").trim() : "OTHERS" ;
    if (!tabs.includes(type) && type !== "OTHERS") {
      tabs.push(type);
    }
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(item);
    return acc;
  }, {});
  const [activeTab, setActiveTab] = useState(tabs[0] || null);
  const [expandedQuestion, setExpandedQuestion] = useState<number | null>(
    categorizedFAQs[tabs[0]]?.length > 0 ? 0 : null
  );

  const toggleQuestion = (index: number) => {
    setExpandedQuestion((prev) => (prev === index ? null : index));
  };
  return (
    <section>
      <div className={cn("lg:col-span-8", styles.faqblock)}>
        <h2
          className={cn("text-2xl font-medium mb-8", styles.mainHeadingFaq)}
        >
          Frequently Asked Questions
        </h2>
        {/* Tabs */}
        {tabs.length > 0 ? (
          <div className="flex gap-2 mb-6 flex-wrap">
            {tabs.map((tab) => (
              <button
                disabled={activeTab === tab}
                key={tab}
                className={cn(
                  "px-4 py-2 text-sm font-semibold rounded-lg",
                  styles.tabBtnFaq,
                  {
                    [styles.activeTabFaq]: activeTab === tab, // Active tab styles
                    [styles.deactiveTabFaq]: activeTab !== tab, // Inactive tab styles
                  }
                )}
                onClick={() => {
                  setActiveTab(tab);
                  setExpandedQuestion(
                    categorizedFAQs[tab]?.length > 0 ? 0 : null // Expand the first question in the selected tab
                  );
                }}
              >
                {tab}
              </button>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No FAQs available.</p>
        )}
        {/* Questions */}
        {activeTab && categorizedFAQs[activeTab]?.length > 0 ? (
          <div className="md:px-0 px-4 space-y-4">
            {categorizedFAQs[activeTab].map((faq, index) => (
              <div
                key={index}
                className={`${
                  expandedQuestion === index ? "text-gray-800" : "text-gray-700"
                }`}
              >
                <div
                  className="flex justify-between items-center cursor-pointer py-1"
                  onClick={() => toggleQuestion(index)}
                >
                 {faq.Question? <span className={cn("font-medium", styles.faqQue, {
                    [styles.activeQuestion] : expandedQuestion === index
                  })}>
                    {faq.Question}
                  </span>:<span className={cn("font-medium", styles.faqQue, {
                    [styles.activeQuestion] : expandedQuestion === index
                  })} dangerouslySetInnerHTML={{__html : faq.QuestionCK}}></span>}
                  <span className={styles.icon}>
                    <ArrowSVG
                      rotate={expandedQuestion === index ? 180 : 0}
                      width={16}
                      height={16}
                      isActive={expandedQuestion === index} 
                      color="blue"
                    />
                  </span>
                </div>
                {expandedQuestion === index && (
                faq.Type === "SPECIALIZATION" ? (
                  <ul className={cn("!text-[#1A1A1A]-600", styles.faqAns)} dangerouslySetInnerHTML={{ __html: faq.Answer }} />
                ) : faq.Answer ? (
                  <p className={cn("!text-[#1A1A1A]-600", styles.faqAns)}>
                    {faq.Answer}
                  </p>
                ) : (
                  <div className={cn("!text-[#1A1A1A]-600", styles.faqAns, styles.faqAnsCk)} dangerouslySetInnerHTML={{ __html: faq.AnswerCK }} />
                )
              )}

              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-600">No FAQs available for this category.</p>
        )}
      </div>
    </section>
  );
};

export default FaqWithCategory;
